var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outData)?_c('div',{staticClass:"main",style:({
  backgroundImage: _vm.showBgImg ? 'url(' + _vm.outData.bg_img + ')' : '',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% auto'
})},[_c('zy-header',{attrs:{"mod":_vm.navStyle}}),(_vm.$slots.default)?_c('div',{staticClass:"zy-container"},[_vm._t("default")],2):_vm._e(),(_vm.$slots.full)?_c('div',{staticClass:"zy-full"},[_vm._t("full")],2):_vm._e(),_c('zy-footer',{attrs:{"mod":_vm.footerStyle}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }